import React from 'react';
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave, faTimes } from '@fortawesome/free-solid-svg-icons';

class Crear extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        ano: '',mes:'',oferta:'',usuario: window.localStorage.getItem('nombre'),
        errores: []
    }
    cambioValor = (e) => {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState({ state, errores: [] })
    }
    verificarError(elemento) {
        return this.state.errores.indexOf(elemento) !== -1;
    }
    enviarDatos = (e) => {
        e.preventDefault();
        const { ano,mes,oferta,usuario } = this.state;
        var errores = [];
        if (!ano) { errores.push("error_ano"); }
        this.setState({ errores: errores });
        if (errores.length > 0) {
            return false;
        }
        if (!mes) { errores.push("error_mes"); }
        this.setState({ errores: errores });
        if (errores.length > 0) {
            return false;
        }
        if (!oferta) { errores.push("error_oferta"); }
        this.setState({ errores: errores });
        if (errores.length > 0) {
            return false;
        }
        var datosEnviar = {
            ano,mes,oferta,usuario
        }
        Swal.showLoading();
        authAxios.post("ipp/registrar", datosEnviar)
            .then((datosRespuesta) => {
                console.log(datosRespuesta)
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.close();
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                if (datosRespuesta.data.Status) {
                    Swal.close();
                    Swal.fire(
                        'Tipo ipp!',
                        datosRespuesta.data.msj,
                        'success'
                    )
                    this.props.history.push("/MasterIpp");
                } else {
                    Swal.close();
                    Swal.fire(
                        'Tipo ipp!',
                        datosRespuesta.data.msj,
                        'error'
                    )
                }
            })
            .catch(console.log)
    }
    render() {
        const { ano,mes,oferta,usuario } = this.state;
        return (
            <div className="content-wrapper">
                <div className="content">
                    <div className="container-fluid">
                        <br />
                        <div className="card">
                            <div className="card-header text-center">
                                <b>REGISTRO DE IPP</b>
                            </div>
                            <div className="card-body">
                                <form onSubmit={this.enviarDatos}>
                                    <div className="row">
                                        <div className="col-xl-12">
                                            <div className='row g-3'>
                                                <div className="col-md-10">
                                                    <label htmlFor="nombre">Año</label>
                                                    <input type="hidden" name="usuario" value={usuario} />
                                                    <input style={{ textTransform: 'uppercase' }} className={((this.verificarError("error_ano")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="ano" id="ano" value={ano} placeholder="Año" aria-describedby="helpId" onChange={this.cambioValor} />
                                                    <small id="helpId" className="invalid-feedback">Digite el Año</small>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xl-12">
                                            <div className='row g-3'>
                                                <div className="col-md-10">
                                                    <label htmlFor="nombre">Mes</label>
                                                    <input style={{ textTransform: 'uppercase' }} className={((this.verificarError("error_mes")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="mes" id="mes" value={mes} placeholder="mes" aria-describedby="helpId" onChange={this.cambioValor} />
                                                    <small id="helpId" className="invalid-feedback">Digite el Mes</small>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xl-12">
                                            <div className='row g-3'>
                                                <div className="col-md-10">
                                                    <label htmlFor="nombre">Valor Oferta</label>
                                                    <input style={{ textTransform: 'uppercase' }} className={((this.verificarError("error_oferta")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="oferta" id="oferta" value={oferta} placeholder="Valor oferta" aria-describedby="helpId" onChange={this.cambioValor} />
                                                    <small id="helpId" className="invalid-feedback">Digite el valor</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className='row'>
                                        <div className='col-xl-12 text-center'>
                                            <div className="btn-group" role="group" aria-label="">
                                                <button type="submit" className="btn btn-success btn-sm"><FontAwesomeIcon icon={faSave} />&nbsp;&nbsp;Crear Tipo ipp</button>&nbsp;&nbsp;
                                                <Link className="btn btn-danger btn-sm" to={"/MasterIpp"}><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancelar</Link>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Crear;